import type JSZip from "jszip";
import { type MediaDataRoomJobResultTransform } from "features/mediaDataRoom/hooks";
import { type LookalikeAudienceStatisticsFileStructure } from "features/mediaDataRoom/models";

export const transformLookalikeAudienceStatistics: MediaDataRoomJobResultTransform<
  LookalikeAudienceStatisticsFileStructure
> = async (zip: JSZip) => {
  const audienceStatisticsFile = zip.file("lookalike_audience.json");
  if (audienceStatisticsFile === null) {
    throw new Error("lookalike_audience.json not found in zip");
  }
  const audienceStatisticsFileStructure = JSON.parse(
    await audienceStatisticsFile.async("string")
  ) as LookalikeAudienceStatisticsFileStructure;
  return audienceStatisticsFileStructure;
};
